import React, { createContext, useContext, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const libraries = ['places'];

const loaderOptions = {
    id: 'google-map-script', 
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: libraries,
};

const MapContext = createContext({
    isLoaded: false,
    loadError: null,
});

export const MapProvider = ({ children }) => {
    const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

    // [修改] 更激進地攔截所有 Google Fonts 請求
    useEffect(() => {
        const head = document.getElementsByTagName('head')[0];
        
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // 1. 攔截 <link> 標籤
                    if (node.tagName === 'LINK') {
                        // 只要 href 包含 fonts.googleapis.com，不管它是 Roboto 還是 Google Sans，通通移除
                        if (node.href && (node.href.includes('fonts.googleapis.com') || node.href.includes('fonts.gstatic.com'))) {
                            node.remove();
                            // console.log('Blocked Google Font Link:', node.href);
                        }
                    }
                    
                    // 2. 攔截 <style> 標籤 (有些字體是通過 inline style 注入的)
                    if (node.tagName === 'STYLE') {
                        // 檢查內容是否引用了 Google Fonts
                        if (
                            node.innerHTML.includes('fonts.googleapis.com') || 
                            node.innerHTML.includes('font-family: Roboto') || 
                            node.innerHTML.includes('font-family: "Google Sans"')
                        ) {
                            node.remove();
                            // console.log('Blocked Google Font Style');
                        }
                    }
                });
            });
        });

        observer.observe(head, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    const value = { isLoaded, loadError };

    return (
        <MapContext.Provider value={value}>
            {children}
        </MapContext.Provider>
    );
};

export const useGoogleMap = () => {
    const context = useContext(MapContext);
    if (context === undefined) {
        throw new Error('useGoogleMap must be used within a MapProvider');
    }
    return context;
};